import { c as _c } from "react/compiler-runtime";
import type { EntityOnboardingBusinessInfo } from '@onefootprint/request-types/dashboard';
import { Shimmer } from '@onefootprint/ui';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import useEntity from '@/components/entities/components/details/hooks/use-entity';
const BusinessLink = t0 => {
  const $ = _c(10);
  const {
    businessInfo
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.moreInformation"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const {
    fpBid,
    onboardingId
  } = businessInfo;
  const {
    data: business,
    isPending
  } = useEntity(fpBid);
  let t2;
  if ($[1] !== business?.data) {
    t2 = business?.data.find(_temp)?.value;
    $[1] = business?.data;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const businessName = t2 as string;
  if (isPending) {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Shimmer height="20px" width="200px" />;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  const t3 = `/businesses/${fpBid}?onboarding_id=${onboardingId}`;
  let t4;
  if ($[4] !== businessName || $[5] !== t) {
    t4 = businessName || t(_temp2);
    $[4] = businessName;
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <Link href={t3} className="text-accent text-label-2">{t4}</Link>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default BusinessLink;
function _temp(attribute) {
  return attribute.identifier === "business.name";
}
function _temp2($) {
  return $.business;
}